/** Filtros do jardim em /content. Sem nota na página, sai sem fazer nada. */
export const setupGarden = () => {
  const list = document.querySelector<HTMLElement>('[data-garden-list]');
  if (!list) return;

  const cards = Array.from(list.querySelectorAll<HTMLElement>('.note-card'));
  const buttons = Array.from(document.querySelectorAll<HTMLButtonElement>('[data-garden-filter]'));
  const count = document.querySelector<HTMLElement>('[data-garden-count]');
  const empty = document.querySelector<HTMLElement>('[data-garden-empty]');
  const active = new Set<string>();

  const update = () => {
    let visible = 0;
    cards.forEach((card) => {
      const facets = (card.dataset.facets ?? '').split(' ');
      // Filtros somam: cada seleção estreita o resultado em vez de ampliá-lo.
      const matches = [...active].every((facet) => facets.includes(facet));
      card.hidden = !matches;
      if (matches) visible += 1;
    });
    buttons.forEach((button) => {
      const on = active.has(button.dataset.gardenFilter ?? '');
      button.classList.toggle('is-active', on);
      button.setAttribute('aria-pressed', String(on));
    });
    if (count) count.textContent = String(visible);
    if (empty) empty.hidden = visible !== 0;
  };

  buttons.forEach((button) =>
    button.addEventListener('click', () => {
      const facet = button.dataset.gardenFilter ?? '';
      if (active.has(facet)) active.delete(facet); else active.add(facet);
      update();
    }),
  );

  document.querySelector<HTMLButtonElement>('[data-garden-clear]')?.addEventListener('click', () => {
    active.clear();
    update();
  });

  update();
};
